import Fieldset from "components/form/Fieldset";
import FormRow from "components/form/FormRow";
// import CheckboxInput from "components/form/input/CheckboxInput";
import ImageInput from "components/form/input/ImageInput";
import TextInput from "components/form/input/TextInput";

export default function ApontamentoImages({ visita, label, name = "images" }) {
    function handleRemoveImage(image) {
        if (image.imagem) {
            visita.deleteImage(image.imagem);
        }
    }

    return (
        <Fieldset label={label || "Imagens da Amostra"} fullWidth>
            <FormRow>
                <ImageInput name={name} geolocationField="georeferencia" multiple onRemove={handleRemoveImage}>
                    <FormRow>
                        <TextInput name="descricao" label="Descrição" multiline rows={4} />
                    </FormRow>

                    {/* <FormRow>
                        <CheckboxInput name="confirmaRelatorio" label="Relatório" />
                    </FormRow> */}
                </ImageInput>
            </FormRow>
        </Fieldset>
    );
}
